<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>Part One</span></p>
<p class="part-h1"><span>M<span class="smallcaps">AGNETISMS</span></span></p>
<p class="part-left1"><i>For it’s well known that bodies act one upon another by the attractions of gravity, magnetism, and electricity; and these instances shew the tenor and course of Nature, and make it not improbable but that there may be more attractive forces than these</i>.</p>
<p class="part-right1"><span>—Sir Isaac Newton,</span></p>
<p class="part-right1a"><span><i>Optics</i> 1717</span></p>
<p class="part-left11"><span><i>Wherever law ends, tryanny begins …</i></span></p>
<p class="part-right3"><span>—John Locke,</span></p>
<p class="part-right11"><span><i>Second Treatise of Government</i> 1689</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?14d4d462